import React from 'react';
import * as I18n from 'src/utils/i18n';
import './index.scss';

export default class Deal extends React.PureComponent {
  state = {
    shouldShowMore: false,
  };

  render() {
    const { shouldShowMore } = this.state;
    const { productLightCustomizationList, children, price = {} } = this.props;
    const { unitEven } = price;
    // 默认展示前两个
    if (!productLightCustomizationList.length && children)
      return (
        <dl className="customize customize-list">
          <dt className="name market-action-list__dt">
            {I18n.get('marketAction.customize')}
          </dt>
          <dd className="value market-action-list__dd">{children}</dd>
        </dl>
      );
    const limit = 2;

    const listToRender = shouldShowMore
      ? productLightCustomizationList
      : productLightCustomizationList.slice(0, limit);
    return (
      productLightCustomizationList &&
      productLightCustomizationList.length > 0 && (
        <dl className="customize customize-list">
          <dt className="name market-action-list__dt">
            {I18n.get('marketAction.customize')}
          </dt>
          <dd className="value market-action-list__dd">
            {children}
            {listToRender.map((item, index) => (
              <div
                className="customization-list-item"
                key={`customization-${index}`}
              >
                {item.customType}
                <span className="customization-list-item-moq">
                  ({I18n.get('productsListView.MinOrder')} {item.moq} {unitEven}
                  )
                </span>
              </div>
            ))}

            {productLightCustomizationList.length > limit ? (
              <p
                className="customize-list-more"
                onClick={e => {
                  e.preventDefault();
                  this.setState({
                    shouldShowMore: !shouldShowMore,
                  });
                }}
              >
                {shouldShowMore
                  ? I18n.get('marketAction.less')
                  : I18n.get('marketAction.more')}
                <span className="arrow ui2-icon ui2-icon-xxs ui2-icon-arrow-down" />
              </p>
            ) : null}
          </dd>
        </dl>
      )
    );
  }
}
